<template>
  <div class="container pt-5">
    <div class="row">
      <div class="col text-align-center border-bottom border-top border-primary mb-5">
        <h3 class="mt-3">Contact us</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-sm-12 text-align-center my-3">
        <div>
          <img src="../assets/icons/phone-24px.svg" class="mx-2" alt="">
          <a href="tel:+1 (786)633-1231" class="text-decoration-none color-secondary">+1 (786)633-1231</a>
        </div>
        <div class="pt-3">
          <img src="../assets/icons/whatsapp.svg" class="mx-2" alt="">
<!--          <a href="whatsapp://send?phone=17866331231" class="text-decoration-none color-secondary">WhatsApp</a>-->
          <a href="https://api.whatsapp.com/send?phone=17866331231" class="text-decoration-none color-secondary">WhatsApp</a>
        </div>
      </div>
      <div class="col-md-4 col-sm-12 text-align-center cursor-pointer my-3">
        <img src="../assets/icons/chat-24px.svg" class="mx-2" alt="">
        <a data-toggle="modal"
           data-target="#modal-contact-form" class="text-decoration-none color-secondary">Inquire now</a>
      </div>
      <div class="col-md-4 col-sm-12 text-align-center my-3">
        <img src="../assets/icons/email-24px.svg" class="mx-2" alt="">
        <a href="mailto:info@plsluxury.com" class="text-decoration-none color-secondary">info@plsluxury.com</a>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-3"></div>
      <div class="col-md-6 col-sm-12 text-align-center">
        <p class="">PLS Luxury Experiences</p>
        <p class="small">2315 Whirlpool Street</p>
        <p class="small">Suite 119</p>
        <p class="small">New York, NY 14305</p>
        <p class="small">USA</p>
      </div>
      <div class="col-3"></div>
    </div>
  </div>
</template>

<script>
  import ContactForm from './../components/contact-form';


  export default {
    name: 'Contact',
    components: {
      ContactForm
    }
  }
</script>